/**
 * @flow
 * @author: Chinmaya
 */

import styled from 'react-emotion'

export const DropdownContainer = styled('div')`
  padding-top: 0.75em; /* 12/16 */
  background: transparent;
  overflow: auto !important;
  @media (min-width: 320px) and (max-width: 992px) {
    padding-bottom: 1.35em;
  }
`

export const Dropdownlist = styled('ul')`
  background-color: #fff;
  padding: 0.5em 0.5em; /* 8/16 */
  border-radius: 4px;
  line-height: 1.14;
  position: absolute;
  right: 0;
  left: 0;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
`

export const DropdownItems = styled('a')`
  z-index: 2;
  position: relative;
  /* background: white; */
  padding: 0px;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  display: flex;
  border-bottom: none;
  text-decoration: none;
  button {
    flex: 1;
    text-align: center;
    padding: 0.75em 0px; /* 12/16 */
    border-radius: 4px;
    font-size: 0.875em; /* 14/16 */
    color: #43484c;
    background: transparent;
    border: none;
    &:hover {
      color: white;
      background-color: #0e418d;
      text-decoration: none;
    }
  }
`

export const DropdownItemContainer = styled('div')`
  ${'' /* display: flex; */};
`
